/* eslint-disable no-unused-vars */

import _ from 'lodash';
import moment from 'moment';
import { store } from 'redux/store';
import { decodeToken } from './authentication';

const checkTokenIsGoingToExpire = () => {
  const { auth } = store.getState();

  let decodedValue = decodeToken();

  const { iat, exp } = decodedValue;

  if (typeof iat !== 'number' || typeof exp !== 'number' || exp <= iat) {
    return {
      shouldRefresh: false,
      isValid: false
    };
  }

  const now = Math.floor(Date.now() / 1000);
  const halfwayTime = iat + (exp - iat) / 2;

  return {
    // True after half the token lifetime has passed, but before expiry
    shouldRefresh: now >= halfwayTime && now < exp,
    isValid: now < exp
  };
};

export default checkTokenIsGoingToExpire;
